import React, { createContext, useState, useEffect } from 'react'

export const ProductContext = createContext({})

export const ProductProvider = ({ children }) => {
  const [types, setTypes] = useState([])
  const [categories, setCategories] = useState([])
  const [managementStyles, setManagementStyles] = useState([])
  const [goals, setSelectedGoals] = useState([])
  const [mobileFilterInput, setMobileFilterInput] = useState('')
  const [isMobile, setIsMobile] = useState(false)
  const [tabs, setTabs] = useState(null)
  const [selectedTabKey, setSelectedTabKey] = useState()
  const [product, setProduct] = useState()

  useEffect(() => {
    const mediaQuery = matchMedia('(max-width: 767px)')
    setIsMobile(mediaQuery.matches)
    const handleChange = (event) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  function changeTab(key) {
    if (key !== selectedTabKey) {
      tabs.map((t) => {
        const element = document.getElementById(`${product}-${t.key}`)
        if (element) {
          t.key === key
            ? element.classList.remove('u-hidden')
            : element.classList.add('u-hidden')
        }
      })
      setSelectedTabKey(key)
    }
  }

  return (
    <ProductContext.Provider
      value={{
        types,
        setTypes,
        categories,
        setCategories,
        managementStyles,
        setManagementStyles,
        goals,
        setSelectedGoals,
        mobileFilterInput,
        setMobileFilterInput,
        isMobile,
        tabs,
        setTabs,
        changeTab,
        selectedTabKey,
        setSelectedTabKey,
        setProduct,
      }}
    >
      {children}
    </ProductContext.Provider>
  )
}
